import React from "react";

const useScrollPosition = (scrollElementSelector: string, onScrollChange: (scrollTop: number) => any) => {
  const updatePosition = (e: Event) => {
    const winScroll = e.target as HTMLDivElement;
    onScrollChange(winScroll.scrollTop);
  };

  React.useEffect(() => {
    document.querySelector(scrollElementSelector)?.addEventListener("scroll", updatePosition);
    return () => document.querySelector(scrollElementSelector)?.removeEventListener("scroll", updatePosition);
  }, []);
};

export default useScrollPosition;
